import { apiRequest } from '../../shared/api';

export interface IntegrationMessageAttemptItem {
  id: string;
  messageId: string;
  attemptNumber: number;
  attemptedAt: string;
  status: 'PENDING' | 'RUNNING' | 'SUCCESS' | 'FAILED' | 'TIMEOUT' | 'RETRIED';
  httpStatus?: number | null;
  responseCode?: string | null;
  responseMessage?: string | null;
  durationMs?: number | null;
  errorId?: string | null;
  message?: {
    id: string;
    messageType: string;
    direction: string;
    status: string;
    sourceSystem?: string | null;
    targetSystem?: string | null;
    correlationId?: string | null;
  };
}

export interface CreateAttemptPayload {
  attemptNumber?: number;
  status: string;
  httpStatus?: number | null;
  responseCode?: string | null;
  responseMessage?: string | null;
  durationMs?: number | null;
  errorId?: string | null;
}

export const integrationAttemptService = {
  async getAttempts(limit: number = 50): Promise<IntegrationMessageAttemptItem[]> {
    return await apiRequest<IntegrationMessageAttemptItem[]>(`/v1/integrations/attempts?limit=${limit}`);
  },

  async getAttemptsByMessageId(messageId: string): Promise<IntegrationMessageAttemptItem[]> {
    return await apiRequest<IntegrationMessageAttemptItem[]>(`/v1/integrations/messages/${messageId}/attempts`);
  },

  async getLatestAttempt(messageId: string): Promise<IntegrationMessageAttemptItem> {
    return await apiRequest<IntegrationMessageAttemptItem>(`/v1/integrations/messages/${messageId}/attempts/latest`);
  },

  async recordAttempt(messageId: string, payload: CreateAttemptPayload): Promise<IntegrationMessageAttemptItem> {
    return await apiRequest<IntegrationMessageAttemptItem>(`/v1/integrations/messages/${messageId}/attempts`, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }
};
